<template>
  <div class="memberIndex">
    <el-dialog
      :visible.sync="isWarnShow"
      title="供应商有效期过期提醒"
      width="700px"
      class="dialog-wrap form-module"
      :close-on-press-escape="false"
      :show-close="isCloseBtnShow"
      :center="true"
      :close-on-click-modal="false"
    >
      <div style="padding-left: 0.625rem; padding-top: 0.9375rem" class="warn_content">
        <p>
          供应商：{{ loginInfos.SupplierName }}，贵司有效期为{{ loginInfos.EntryTermEndDate }}，{{ isCloseBtnShow ? '距离有效期过期还有' : '已过期'
          }}{{ Math.abs(loginInfos.OverDueLeftDay) }}天
        </p>
        <p>由于有效期过期后将无法参与广电计量任何采购项目，避免影响到正常的业务进行，请点击以下链接及时发起《供应商复评申请》</p>
        <div style="padding-top: 1rem; text-align: center">
          <el-button class="apply_btn" type="primary" @click="goToChangeInform(1)">
            {{ loginInfos.ReAuditState == 1 ? '查看' : '发起' }}供应商复评申请</el-button
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="blackListShow1"
      title="黑名单供应商状态异常提醒"
      width="700px"
      class="dialog-wrap form-module"
      :close-on-press-escape="false"
      :show-close="true"
      :center="true"
      :close-on-click-modal="false"
    >
      <div style="padding-left: 0.625rem; padding-top: 0.9375rem" class="warn_content">
        <p>很遗憾，贵司仍在我司黑名单禁用期限内，禁用期截至{{ resultData.EntryTermEndDate }}</p>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="blackListShow2"
      title="黑名单供应商解禁提醒"
      width="700px"
      class="dialog-wrap form-module"
      :close-on-press-escape="false"
      :show-close="true"
      :center="true"
      :close-on-click-modal="false"
    >
      <div style="padding-left: 0.625rem; padding-top: 0.9375rem" class="warn_content">
        <p>
          贵司已超过我司黑名单禁用期，处于“待激活”状态，若贵司希望与我司重新合作，请发起“黑名单解禁申请流程”，待我司相关评审通过后方能恢复“合格”状态
        </p>
        <div style="padding-top: 1rem; text-align: center">
          <el-button class="apply_btn" type="primary" @click="goToOpeningform()"> 发起黑名单解禁申请流程</el-button>
        </div>
      </div>
    </el-dialog>

    <div class="left" :style="height">
      <div class="logined_wrap">
        <div class="title clear">
          <span>{{ loginInfos.SupplierName }}</span>
          <span v-if="!loginInfos.Certify">
            <img src="@/assets/img/icon_notcertified.png" />
          </span>
          <span v-if="loginInfos.Certify">
            <img src="@/assets/img/icon_certified.png" />
          </span>
        </div>
        <ul class="list">
          <li>
            <img src="@/assets/img/icon_contacts.png" />
            <span>
              <label class="labell">联系人：</label>
              {{ loginInfos.Contact }}({{ loginInfos.Mobile }})
            </span>
          </li>
          <li>
            <img src="@/assets/img/icon_effectivedate.png" />
            <span>
              <label class="labell">有效日期：</label>
              {{ loginInfos.EntryValidTerm }}
            </span>
          </li>
        </ul>
      </div>
      <el-menu :default-active="activeIndex" class="el_menu1" mode="vertical" @select="handleSelect">
        <el-menu-item index="membercenterindex" @click="changeMain('membercenterindex', false)">首页</el-menu-item>
        <el-submenu index="mbInfo">
          <template slot="title">企业信息</template>
          <el-menu-item index="EnterpriseInform" @click="changeMain('EnterpriseInform', true)">查看企业信息</el-menu-item>
          <el-menu-item index="ChangeInform" @click="goToChangeInform(0)">修改企业信息</el-menu-item>
          <el-menu-item index="AccountDataEdit" @click="changeMain('AccountDataEdit', true)">修改账号信息</el-menu-item>
          <el-menu-item index="ContactsChange" @click="changeMain('ContactsChange', true)">修改联系人</el-menu-item>
          <el-menu-item index="AuditRecord" @click="goToAuditRecord(0)">查看审核记录</el-menu-item>
        </el-submenu>
        <el-submenu index="BidManage">
          <template slot="title">招标/比选管理</template>
          <el-menu-item index="InvitationList" @click="changeMain('InvitationList', false)">邀请函接收</el-menu-item>
          <el-menu-item index="TenderDocList" @click="changeMain('TenderDocList', false)">上传投标文件</el-menu-item>
          <el-menu-item index="BidResultList" @click="changeMain('BidResultList', false)">投标结果</el-menu-item>
        </el-submenu>

        <el-submenu index="Negotiation">
          <template slot="title">供应商谈判/单一来源</template>
          <el-menu-item index="Invitation4NegotiationList" @click="changeMain('Invitation4NegotiationList', false)"> 谈判邀请函接收</el-menu-item>
          <el-menu-item index="TenderDoc4NegotiationList" @click="changeMain('TenderDoc4NegotiationList', false)">上传响应文件 </el-menu-item>
          <el-menu-item index="NegotiationList" @click="changeMain('NegotiationList', false)">谈判报价</el-menu-item>
          <el-menu-item index="BidResult4NegotiationList" @click="changeMain('BidResult4NegotiationList', false)">投标结果 </el-menu-item>
        </el-submenu>
        <el-menu-item index="ClarifyList" @click="changeMain('ClarifyList', false)">技术澄清</el-menu-item>

        <el-submenu index="OnlineBidding">
          <template slot="title">在线竞价</template>
          <el-menu-item index="OnlineBiddingList" @click="changeMain('OnlineBiddingList', false)">在线竞价</el-menu-item>
          <el-menu-item index="OnlineBiddingResultList" @click="changeMain('OnlineBiddingResultList', false)">竞价结果 </el-menu-item>
        </el-submenu>
        <el-submenu index="CAManage">
          <template slot="title">证书管理</template>
          <el-menu-item index="CABinding" @click="OpenWindow('CABinding')">绑定证书</el-menu-item>
          <el-menu-item index="ApplyNewCert" @click="OpenWindow('ApplyNewCert')">签章新办</el-menu-item>
          <el-menu-item index="updateLogin" @click="OpenWindow('updateLogin')">签章更新</el-menu-item>
          <el-menu-item index="unlockRequest" @click="OpenWindow('unlockRequest')">签章解锁</el-menu-item>
          <el-menu-item index="certReplace" @click="OpenWindow('certReplace')">签章补办</el-menu-item>
          <el-menu-item index="ScheduleQuery" @click="OpenWindow('ScheduleQuery')">业务进度查询</el-menu-item>
          <el-menu-item index="SupplierOrderList" @click="changeMain('SupplierOrderList')">支付订单查询</el-menu-item>
        </el-submenu>
        <el-menu-item index="QuestionList" @click="changeMain('QuestionList', false)">招标答疑</el-menu-item>
        <el-menu-item index="EvaluationClarifyList" @click="changeMain('EvaluationClarifyList', false)">评标澄清回复 </el-menu-item>
        <el-submenu index="InQuiry">
          <template slot="title">在线报价</template>
          <el-menu-item index="InQuiryDetailList" @click="changeMain('InQuiryDetailList', false)">我要报价</el-menu-item>
          <el-menu-item index="CommittingOfferList" @click="changeMain('CommittingOfferList', false)">我的待提交报价 </el-menu-item>
          <el-menu-item index="CommittedOfferList" @click="changeMain('CommittedOfferList', false)">我的已提交报价 </el-menu-item>
        </el-submenu>
        <el-submenu index="Contract">
          <template slot="title">我的合同</template>
          <el-menu-item index="ContractList" @click="changeMain('ContractList', false)">合同跟进（{{ contarctCount }}）</el-menu-item>
          <el-menu-item index="ArrivalFollowList" @click="changeMain('ArrivalFollowList', false)">交货跟进（{{ arrivalFollowCount }}） </el-menu-item>
          <el-menu-item index="ExamineFollowList" @click="changeMain('ExamineFollowList', false)"
            >逾期考核跟进（{{ arrivalExamineCount }}）
          </el-menu-item>
          <el-menu-item index="PayFollowList" @click="changeMain('PayFollowList', false)">请款跟进（{{ payFollowCount }}） </el-menu-item>
        </el-submenu>

        <!-- <el-submenu index="Order">
          <template slot="title">PO单</template>
          <el-menu-item index="OrderList" @click="changeMain('OrderList', false)">我的PO单</el-menu-item>
          <el-menu-item index="ReconciliationList" @click="changeMain('ReconciliationList', false)">月度对账</el-menu-item>
        </el-submenu> -->
      </el-menu>
    </div>
    <div class="right">
      <component :is="currentComponent" mode="out-in"></component>
    </div>
  </div>
</template>

<script>
import membercenterindex from '@/views/MemberCenter/index'

import Invitation4NegotiationList from '@/views/Negotiation/InvitationList'
import TenderDoc4NegotiationList from '@/views/Negotiation/TenderDocList'
import BidResult4NegotiationList from '@/views/Negotiation/BidResultList'
import Clarify4NegotiationList from '@/views/Negotiation/ClarifyList'

import InvitationList from '@/views/InvitationManage/InvitationList'
import TenderDocList from '@/views/InvitationManage/TenderDocList'
import BidResultList from '@/views/InvitationManage/BidResultList'
import ClarifyList from '@/views/InvitationManage/ClarifyList'
import NegotiationList from '@/views/Negotiation/NegotiationList'
import QuestionList from '@/views/QuestionManage/QuestionList'
import EvaluationClarifyList from '@/views/EvaluationClarify/EvaluationClarifyList'

import OnlineBiddingList from '@/views/OnlineBidding/OnlineBiddingList'
import OnlineBiddingResultList from '@/views/OnlineBidding/OnlineBiddingResultList'

import InQuiryDetailList from '@/views/InQuiryPrice/DetailList'
import CommittingOfferList from '@/views/InQuiryPrice/CommittingOfferList'
import CommittedOfferList from '@/views/InQuiryPrice/CommittedOfferList'
import ContractList from '@/views/Contract/ContractList'
import AcceptanceFollowList from '@/views/Contract/AcceptanceFollowList'
import ArrivalFollowList from '@/views/Contract/ArrivalFollowList'
import ExamineFollowList from '@/views/Contract/ExamineFollowList'
import PayFollowList from '@/views/Contract/PayFollowList'
import OrderList from '@/views/Order/OrderList'
import ReconciliationList from '@/views/Order/ReconciliationList'

import SupplierOrderList from '@/views/CAManage/SupplierOrderList'
export default {
  name: 'aboutUs',
  components: {
    membercenterindex,
    InvitationList,
    TenderDocList,
    BidResultList,
    ClarifyList,
    NegotiationList,
    Invitation4NegotiationList,
    TenderDoc4NegotiationList,
    BidResult4NegotiationList,
    Clarify4NegotiationList,
    QuestionList,
    EvaluationClarifyList,
    OnlineBiddingList,
    InQuiryDetailList,
    CommittingOfferList,
    CommittedOfferList,
    OnlineBiddingResultList,
    ContractList,
    ReconciliationList,
    OrderList,
    SupplierOrderList,
    AcceptanceFollowList,
    ArrivalFollowList,
    ExamineFollowList,
    PayFollowList,
    contarctCount: 0,
    arrivalFollowCount: 0,
    arrivalExamineCount: 0,
    payFollowCount: 0
  },
  data() {
    return {
      currentComponent: 'membercenterindex',
      height: {
        height: ''
      },
      activeIndex: 'membercenterindex',
      flexData: [
        { num: '1', title: '今日报价' },
        { num: '2', title: '整改通知' }
      ],
      Certify: true,
      isWarnShow: false,
      isCloseBtnShow: true,
      aboutTab: '1',
      activeName: 'default',
      projectName: 'defaultPJ',
      loginInfos: {},
      biddlist1: [
        { type: '邀请招标', title: '关于“广电计量直流低电阻校准装置采购项目”中标的公告', date: '2020-04-21 11:14' },
        { type: '招标', title: '关于“广电计量直流低电阻校准装置采购项目”中标的公告', date: '2020-04-21 11:14' },
        { type: '单一来源', title: '关于“广电计量直流低电阻校准装置采购项目”中标的公告', date: '2020-04-21 11:14' },
        { type: '邀请招标', title: '关于“广电计量直流低电阻校准装置采购项目”中标的公告', date: '2020-04-21 11:14' }
      ],
      tableData: [
        { name: '2020年频率计采购项目（第二次）”询价公告', publishDate: '2020-05-15 11:18', endDate: '2020-05-15 11:18' },
        { name: '2020年频率计采购项目（第二次）”询价公告', publishDate: '2020-05-15 11:18', endDate: '2020-05-15 11:18' },
        { name: '2020年频率计采购项目（第二次）”询价公告', publishDate: '2020-05-15 11:18', endDate: '2020-05-15 11:18' },
        { name: '2020年频率计采购项目（第二次）”询价公告', publishDate: '2020-05-15 11:18', endDate: '2020-05-15 11:18' }
      ],
      resultData: {},
      blackListShow1: false,
      blackListShow2: false
    }
  },
  created() {
    this.heightCom()
  },
  computed: {},
  mounted() {
    this.getContractCount()
    this.getData()
    this.ValidateBlacklistStatus()
  },
  methods: {
    goToChangeInform(type) {
      this.getRequest('SupplierLogin/ValidateBlacklistStatus')
        .then((res) => {
          if (res.data.errcode == 0 || res.data.errcode == 4) {
            this.$router.push({
              path: '/ChangeInform',
              query: {
                pageType: type
              }
            })
          } else if (res.data.errcode == 1) {
            this.$message.error(res.data.errmsg)
          } else if (res.data.errcode == 2) {
            this.resultData = res.data.resultData
            this.blackListShow1 = true
          } else if (res.data.errcode == 3) {
            this.blackListShow2 = true
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    goToAuditRecord(type) {
      this.$router.push({
        path: '/AuditRecord',
        query: {
          pageType: type
        }
      })
    },
    heightCom() {
      this.height.height = window.innerHeight - 60 + 'px'
    },
    goDetail() {
      this.$router.push('/Notify')
    },
    handleNotify(val) {
      console.log(val)
    },
    handleProject(val) {
      console.log(val)
    },
    handleSelect(val) {
      console.log(val)
    },
    getContractCount() {
      this.getRequest('Contract/ContractCount')
        .then((res) => {
          if (res.data.errcode == 0) {
            this.contarctCount = res.data.contarctCount
            this.arrivalFollowCount = res.data.arrivalFollowCount
            this.arrivalExamineCount = res.data.arrivalExamineCount
            this.payFollowCount = res.data.payFollowCount
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getData() {
      // var loginToken = window.localStorage.getItem("loginToken");
      this.getRequest('SupplierLogin/MemberCenterData')
        .then((res) => {
          if (res.data.errcode == 0) {
            this.loginInfos = res.data.logindata
            this.isWarnShow = this.loginInfos.IsOverDueWarn
            this.isCloseBtnShow = this.loginInfos.OverDueLeftDay >= 0
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    ValidateBlacklistStatus() {
      this.getRequest('SupplierLogin/ValidateBlacklistStatus')
        .then((res) => {
          if (res.data.errcode == 0) {
          } else if (res.data.errcode == 1) {
            this.$message.error(res.data.errmsg)
          } else if (res.data.errcode == 2) {
            this.resultData = res.data.resultData
            this.blackListShow1 = true
          } else if (res.data.errcode == 3) {
            this.blackListShow2 = true
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    OpenWindow(route) {
      //打开回执界面
      let routerData = this.$router.resolve({
        name: route
      })
      window.open(routerData.href, '_blank')
      // window.open(route, "_blank");
    },
    changeMain(rout, isroute) {
      //第一个参数是路由地址，不用加/，第二个是是否跳转其他页面。
      if (isroute) {
        this.$router.push('/' + rout)
      } else {
        //只加载右边页面，需配置component路由
        if (this.currentComponent === rout) {
          var componentA = {
            template: `<div></div>`
          }
          this.currentComponent = componentA
        }
        setTimeout(() => {
          this.currentComponent = rout
        }, 1)
      }
    },
    goToOpeningform() {
      this.$router.push({
        path: '/unbanInform4Member',
        query: {
          ruleForm: '',
          isEnter: false
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.memberIndex {
  display: flex;

  .left {
    width: 250px;
    min-width: 250px;
    background: #4f99d7;

    .logined_wrap {
      padding: 10px;

      .title span:nth-of-type(1) {
        font-weight: bold;
        color: #fff;
        margin-right: 5px;
      }

      .btn {
        border-top: 1px dashed #2db7f5;
        padding-top: 10px;
        margin-top: 10px;
      }

      .btn_1 {
        width: 100%;
      }

      .img {
        margin-left: 30px;
      }

      .list {
        li {
          font-size: 12px;
          padding: 5px 0;
          color: #d3e7f3;
          display: flex;
          align-items: center;

          .labell {
            font-weight: bold;
          }

          img {
            margin-right: 5px;
          }
        }
      }
    }
  }

  .right {
    width: calc(100vw - 250px);
    background: #e4e4e4;
    // flex: 1;
    padding: 0 0 10px 0;

    .right_out {
      width: 98%;
      margin: 0 auto;
    }

    .welcome {
      height: 40px;
      line-height: 40px;
    }
  }

  .block_wrap {
    display: flex;
  }

  .left_block {
    flex: 3;

    .flex_block {
      display: flex;

      .block {
        flex: 1;
        background: #fff;
        margin-right: 20px;
        text-align: center;
        align-items: center;
        padding: 13px 0;

        .text1 {
          font-size: 46px;
          color: #219cf8;
        }

        .text2 {
          margin-top: 4px;
          color: #054c81;
        }
      }

      .block:nth-last-of-type(1) {
        margin-right: 0;
      }
    }
  }

  .flex_bottom {
    padding: 10px 15px 3px;
    background: #fff;
    margin-top: 10px;

    .fb_title {
      margin-bottom: 0;
    }
  }

  .right_block {
    width: 220px;
    background: #fff;
    margin-left: 10px;
    padding: 18px 15px 0;

    .text {
      font-size: 16px;
      border-bottom: 1px solid #95c7f0;
      padding-bottom: 3px;
      font-weight: bold;
    }

    .row_imgs {
      display: flex;
      margin: 15px 0 25px;

      .img_block {
        flex: 1;
        text-align: center;
        cursor: pointer;

        img {
          margin-bottom: 20px;
        }
      }
    }

    .row_imgs:nth-last-of-type(1) {
      margin-top: 33px;
    }
  }
}

::v-deep .el-dialog__title {
  font-size: 28px !important;
  font-weight: bold !important;
}

.warn_content p {
  text-indent: 2em;
  line-height: 2em;
  font-size: 20px;
}

.apply_btn {
  height: 43px;
  font-size: 20px;
  background-color: rgba(7, 116, 215, 1);
  border-radius: 10px;
}
</style>